'use client'

import { clsx } from 'shared/libs/style-merge'

import { Category } from 'modules/Category/model/types'
import { CategoryLinkCard } from 'modules/Category/ui/CategoryLinkCard/Desktop'
import { useGetShopsCountQuery } from 'modules/Shop/model/api'

import { Divider } from 'shared/ui/divider'

import { RouterPath } from 'shared/config/routerPath/RouterPath'

import styles from './CategorySidebar.module.scss'

interface CategorySidebarProps {
  setHoveredCategory: (category: Category | null) => void
  hoveredCategory: Category | null
  categories: Category[]
}
export function CategorySidebar({
  setHoveredCategory,
  hoveredCategory,
  categories,
}: CategorySidebarProps) {
  const { data } = useGetShopsCountQuery()

  return (
    <aside className={clsx(styles.sidebar, 'customScrollbar')}>
      <CategoryLinkCard
        icon={'/static/svg/shopLogo.svg'}
        imageSize={45}
        title="Магазины"
        subtitle={data?.shops_count ? `${data?.shops_count} продавцов` : ''}
        id={455}
        className={styles.shopButton}
        link={RouterPath.SHOP}
      />
      <Divider type="horizontal" margin="medium" />
      <CategoryLinkCard
        className={styles.discountButton}
        isDiscount
        title={'Жаркие скидки'}
        icon={'/static/svg/discount.svg'}
        id={'discounted'}
      />
      <div>
        {categories?.map(category => (
          <div
            key={category.id}
            onMouseEnter={() => setHoveredCategory(category)}
            onMouseLeave={() => setHoveredCategory(category)}
          >
            <CategoryLinkCard
              className={clsx(styles.categoryLink, {
                [styles.active]: category.slug === hoveredCategory?.slug,
              })}
              link={`${RouterPath.CATEGORY}/?categoryId=${category.slug}`}
              title={category.name}
              icon={category.icon}
              id={category.slug}
            />
          </div>
        ))}
      </div>
    </aside>
  )
}
